module.exports = __webpack_public_path__ + "static/media/logo.a114d996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/logo.svg
// module id = 141
// module chunks = 0